import { render, staticRenderFns } from "./client-field-edit-form.html?vue&type=template&id=0c32115d&scoped=true&"
import script from "./client-field-edit-form.js?vue&type=script&lang=js&"
export * from "./client-field-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32115d",
  null
  
)

export default component.exports